import { clsx } from 'clsx';
import React, { useContext, useState, useRef, useEffect } from 'react';
import { TooltipTrigger, TooltipTriggerStateContext, Tooltip as Tooltip$1 } from 'react-aria-components';
import { FocusableTrigger } from './FocusableTrigger.es.js';

const tooltipBase = "_tooltip-base_1c7gh_1";
const tooltipSingleLine = "_tooltip-single-line_1c7gh_11";
const tooltipMultiLine = "_tooltip-multi-line_1c7gh_17";
const styles = {
	tooltipBase: tooltipBase,
	tooltipSingleLine: tooltipSingleLine,
	tooltipMultiLine: tooltipMultiLine
};

const LINE_HEIGHT = 24;
const PADDING_Y = 2;
const SINGLE_LINE_HEIGHT = LINE_HEIGHT + PADDING_Y * 2;
const TOOLTIP_PLACEMENTS = [
  "bottom",
  "bottom left",
  "bottom right",
  "top",
  "top left",
  "top right",
  "left",
  "left top",
  "left bottom",
  "right",
  "right top",
  "right bottom"
];
const OFFSET_VALUES = {
  small: 4,
  medium: 8,
  large: 12
};
const getOffsetValue = (offset = "medium") => {
  if (typeof offset === "number") {
    return offset;
  }
  return OFFSET_VALUES[offset];
};
const Tooltip = ({ allowMultiline = false, children, content, isOpen, offset = "medium", onOpenChange, placement = "bottom" }) => {
  return React.createElement(
    TooltipTrigger,
    { closeDelay: 200, delay: 200, isOpen, onOpenChange },
    children,
    React.createElement(TooltipContent, { allowMultiline, content, offset, placement })
  );
};
const TooltipContent = ({ allowMultiline, content, offset, placement }) => {
  var _a;
  const state = useContext(TooltipTriggerStateContext);
  const isOpen = (_a = state === null || state === void 0 ? void 0 : state.isOpen) !== null && _a !== void 0 ? _a : false;
  const [isMultiline, setIsMultiLine] = useState(allowMultiline);
  const tooltipRef = useRef(null);
  useEffect(() => {
    if (tooltipRef.current) {
      const tooltipHeight = tooltipRef.current.getBoundingClientRect().height;
      const isMultiLine = tooltipHeight > SINGLE_LINE_HEIGHT;
      setIsMultiLine(isMultiLine);
    }
  }, [isOpen]);
  return React.createElement(Tooltip$1, { className: clsx(styles.tooltipBase, !allowMultiline && styles.tooltipSingleLine, isMultiline && styles.tooltipMultiLine), "data-zds": true, offset: getOffsetValue(offset), placement, ref: tooltipRef }, content);
};
Tooltip.FocusableTrigger = FocusableTrigger;

export { TOOLTIP_PLACEMENTS, Tooltip, Tooltip as default };
//# sourceMappingURL=Tooltip.es.js.map
